import type { AuthUser } from "@/types/auth";

import i18next from "i18next";
import { useEffect } from "react";

const APP_ID = "720475fc-8430-4601-84d9-ca561740b263";
const WIDGET_SRC = "https://embed.helpcrunch.com/sdk.js";

function bootstrap() {
  window.helpcrunchSettings = {
    organization: "meteam",
    appId: APP_ID,
  };
}

function loadScript() {
  const hS = window.helpcrunchSettings;
  if (!hS || !hS.organization) return;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  window.HelpCrunch = function (...args: any[]) {
    window.HelpCrunch.q.push(args);
  };
  window.HelpCrunch.q = [];

  if (document.querySelector(`script[src="${WIDGET_SRC}"]`)) return;

  const s = document.createElement("script");
  s.async = true;
  s.type = "text/javascript";
  s.src = WIDGET_SRC;
  (document.body || document.head).appendChild(s);
}

function setupHelpCrunch(user: AuthUser | null) {
  if (user) {
    window.HelpCrunch("updateUser", {
      email: user.username,
      user_id: user.id,
    });
  }

  window.HelpCrunch("showChatWidget");

  window.HelpCrunch("onChatOpen", () => {
    const locale = i18next.language.toUpperCase();

    if (typeof window.gtag === "function") {
      window.gtag("event", "click_chat", { site_language: locale });
    }

    if (typeof window.rdt === "function") {
      window.rdt("track", "Custom", { customEventName: "click_chat" });
    }
  });
}

function useHelpCrunch(enabled = false, user: AuthUser | null = null) {
  useEffect(() => {
    if (!enabled) return;

    bootstrap();
    loadScript();

    const timeoutId = window.setTimeout(() => setupHelpCrunch(user), 3500);

    return () => window.clearTimeout(timeoutId);
  }, [enabled, user]);
}

export default useHelpCrunch;
